import React from "react";

import { Route, Routes } from "react-router-dom";

import { RoutePaths } from "./config/routePaths";
import ActivityHistoryLayoutView from "../layouts/views/ActivityHistoryLayoutView";
import MainLayoutView from "../layouts/views/MainLayoutView";
import { Error } from "../pages/Error/Error";
import { NotFound } from "../pages/NotFound/NotFound";

export default function PublicRouter() {
  return (
    <Routes>
      <Route
        path={RoutePaths.NOT_FOUND}
        element={<NotFound />}
      />
      <Route
        path={RoutePaths.ERROR}
        element={<Error />}
      />
      <Route
        path={RoutePaths.USER_FEEDBACK_LOGS}
        element={<ActivityHistoryLayoutView />}
      />
      <Route
        path={RoutePaths.USER_FEEDBACK_DETAILS}
        element={<MainLayoutView />}
      />
      <Route
        path="*"
        element={<NotFound />}
      />
    </Routes>
  );
}
